import { render } from "./UserVerification.vue?vue&type=template&id=210b7ba4"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__